var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "../../widgetsDictionary";
import { useState } from "react";
import { useGetAdminMenuQuery } from "@/store/api";
import { faChevronDown, faGear, faUsers, } from "@fortawesome/pro-regular-svg-icons";
import { faKey, faLockKeyhole, faShieldKeyhole, faCircleEuro, faLanguage, faGlobeAmericas, faFilePdf, faSearch, faClock, faSwatchbook, faSquareList, faCircle, faAdd, faList, faCalendar, faChevronUp, faDownload, faWrench, faEye, faRefresh, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { setSelectedItemChildren } from "@/store/administrationSlice";
export default function MenuAdmin() {
    var _a, _b;
    var dispatch = useAppDispatch();
    var _c = useState(null), hoveredItem = _c[0], setHoveredItem = _c[1];
    var dataMenu = useGetAdminMenuQuery({}).data;
    var menuList = dataMenu && (dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.data);
    var selectedItemChildren = useAppSelector(function (state) { return state.adminMenu.selected_item_children; });
    var getFontAwesomeIcon = function (icon) {
        var fontAwesomeIcon = faGear;
        switch (icon) {
            case "supervised_user_circle":
                fontAwesomeIcon = faUsers;
                break;
            case "vpn_key":
                fontAwesomeIcon = faLockKeyhole;
                break;
            case "security":
                fontAwesomeIcon = faShieldKeyhole;
                break;
            case "oauth":
                fontAwesomeIcon = faKey;
                break;
            case "monetization_on":
                fontAwesomeIcon = faCircleEuro;
                break;
            case "language":
                fontAwesomeIcon = faLanguage;
                break;
            case "locale":
                fontAwesomeIcon = faGlobeAmericas;
                break;
            case "pdf-settings":
                fontAwesomeIcon = faFilePdf;
                break;
            case "search":
                fontAwesomeIcon = faSearch;
                break;
            case "theme":
                fontAwesomeIcon = faSwatchbook;
                break;
            case "aobh-businesshours":
                fontAwesomeIcon = faClock;
                break;
            case "modules-and-subpanels":
            case "module-menu-filters":
                fontAwesomeIcon = faSquareList;
                break;
            case "title":
                fontAwesomeIcon = faCircle;
                break;
            case "add":
                fontAwesomeIcon = faAdd;
                break;
            case "list":
                fontAwesomeIcon = faList;
                break;
            case "schedule":
                fontAwesomeIcon = faCalendar;
                break;
            case "import":
                fontAwesomeIcon = faDownload;
                break;
            case "config":
                fontAwesomeIcon = faWrench;
                break;
            case "view":
                fontAwesomeIcon = faEye;
                break;
            case "refresh":
                fontAwesomeIcon = faRefresh;
                break;
            default:
                fontAwesomeIcon = faGear;
                break;
        }
        return fontAwesomeIcon;
    };
    var _d = useState(null), openMenuIndex = _d[0], setOpenMenuIndex = _d[1];
    var toggleMenu = function (index) {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
        localStorage.setItem("adminPath", window.location.pathname);
    };
    return (_jsxs("div", __assign({ className: "flex h-full" }, { children: [_jsx("div", __assign({ className: "bg-[var(--colors-widget)] w-[250px] p-4 h-full overflow-visible" }, { children: _jsx("div", __assign({ className: "space-y-2" }, { children: menuList &&
                        menuList.map(function (group, gIndex) {
                            var hasSubMenu = group.items && group.items.length > 0;
                            var isOpen = openMenuIndex === gIndex;
                            return (_jsxs("div", __assign({ className: "menu-contain ".concat(isOpen ? "open" : "") }, { children: [_jsxs("p", __assign({ onClick: function () { return toggleMenu(gIndex); }, onMouseEnter: function () { return setHoveredItem(group.title); }, onMouseLeave: function () { return setHoveredItem(null); }, className: "relative cursor-pointer flex items-center uppercase justify-between p-2 rounded hover:bg-[var(--colors-widget-hover)] hover:rounded" }, { children: [_jsx("span", { children: group.title }), (isOpen ||
                                                (hoveredItem === group.title && hasSubMenu)) && (_jsx(FontAwesomeIcon, { icon: isOpen ? faChevronUp : faChevronDown, className: "absolute right-0 top-2 mr-4 text-gray-900" }))] })), openMenuIndex === gIndex && (_jsx("ul", __assign({ className: "ml-4 mt-2 space-y-1" }, { children: group.items.map(function (item, i) { return (_jsx("li", __assign({ className: "relative" }, { children: _jsxs("a", __assign({ href: item.url || "#", className: " p-2 rounded hover:bg-[var(--colors-widget-hover)] text-sm flex items-center", onClick: function (e) {
                                                    dispatch(setSelectedItemChildren(item));
                                                } }, { children: [item.icon && (_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(item.icon), className: "mr-2" })), item.label] })) }), i)); }) })))] }), gIndex));
                        }) })) })), _jsx("div", __assign({ className: "w-[300px] h-full bg-slate-200 overflow-y-auto" }, { children: selectedItemChildren && (selectedItemChildren === null || selectedItemChildren === void 0 ? void 0 : selectedItemChildren.children) ? (_jsxs("div", { children: [_jsxs("h3", __assign({ className: "text-lg font-bold mb-2 mt-4 flex items-center p-2" }, { children: [selectedItemChildren.icon && (_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(selectedItemChildren.icon), className: "mr-2 text-gray-400 text-2xl" })), selectedItemChildren.label] })), _jsx("p", { className: "text-gray-500 mb-3 p-2", dangerouslySetInnerHTML: {
                                __html: ((_a = selectedItemChildren.children) === null || _a === void 0 ? void 0 : _a.desc) || "",
                            } }), _jsx("ul", __assign({ className: "mt-4" }, { children: selectedItemChildren &&
                                ((_b = selectedItemChildren === null || selectedItemChildren === void 0 ? void 0 : selectedItemChildren.children.items) === null || _b === void 0 ? void 0 : _b.map(function (child, idx) { return (_jsxs("li", __assign({ className: "cursor-pointer hover:bg-gray-100 p-2 rounded flex items-center", onClick: function () {
                                        if (child.url)
                                            window.location.href = child.url;
                                    } }, { children: [(child === null || child === void 0 ? void 0 : child.icon) && (_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(child.icon), className: "mr-2 text-gray-700" })), child.label] }), idx)); })) }))] })) : (_jsx("span", __assign({ className: "text-gray-400 italic" }, { children: "Selectionner un sous-menu" }))) }))] })));
}
widgetsDictionary.register("widget/admin/menu", {
    name: "Admin menu",
    validation: true,
    display: MenuAdmin,
});
